export enum PermissionTypes {
    read = 'read', // Read/access the data/page
    write = 'write', // Add/Edit the data
}

export enum PermissionConcerns {
    // Existing permissions
    CellNass_Operators = 'CellNass_Operators', // View/Search Operators (maps to CSV: View / Search Operators)
    Customer_Account_Users = 'Customer_Account_Users', // Manage Account User (maps to CSV: Manage Account User)
    Customer_Accounts = 'Customer_Accounts', // Add/Edit Customer (maps to CSV: Add / Edit Customer)
    Delete_Customer = 'Delete_Customer', // Delete Customer (Level 1 & 2 CellTrak only)
    Customers = 'Customers', // View/Search Customers (maps to CSV: View / Search Customers)
    Inventory_Audit_Trails = 'Inventory_Audit_Trails', // See Audit Trail in SidePanel and Tabs
    Inventory_Containers = 'Inventory_Containers', // View/Search Containers (maps to CSV: View / Search Containers)
    Inventory_Locations = 'Inventory_Locations',
    Inventory_Search_Notes = 'Inventory_Search_Notes', // View Non-PII Notes (maps to CSV: View Non-PII Notes)
    Inventory_Sensitive_Notes = 'Inventory_Sensitive_Notes', // View PII Notes (maps to CSV: View PII Notes)
    Navigation_Settings_Accounts = 'Navigation_Settings_Accounts', // Customer Accounts via Settings in NavMenu
    Navigation_Settings_Cellnass = 'Navigation_Settings_Cellnass', // Cellnass Settings in Nav Menu
    Documentation = 'Documentation', // View/Download Documentation (maps to CSV: View / Download Documentation)
    Navigation_Recalls_Customers = 'Navigation_Recalls_Customers', 
    Navigation_Recalls_Operators = 'Navigation_Recalls_Operators', 
    Navigation_Uplifts_Customers = 'Navigation_Uplifts_Customers', 
    Navigation_Uplifts_Operators = 'Navigation_Uplifts_Operators', 
    Navigation_Returns_Customers = 'Navigation_Returns_Customers', 
    Navigation_Returns_Operators = 'Navigation_Returns_Operators', 
    Remove_Account = "Remove_Account", // Permanent Account Removal (maps to CSV: Permanent Account Removal)
    Dispose = "Dispose", // Make A Disposal Request (maps to CSV: Make A Disposal Request)

    // New View/Search permissions
    Cases_And_Ranges = 'Cases_And_Ranges', // View/Search Cases And Ranges
    Specimens = 'Specimens', // View/Search Specimens
    Accounts = 'Accounts', // View/Search Accounts
    Account_Storage_Summary = 'Account_Storage_Summary', // View Account Storage Summary
    Account_Users = 'Account_Users', // View/Search Account Users
    Account_Address_Book = 'Account_Address_Book', // View Account Address Book
    Account_Invoices = 'Account_Invoices', // View/Search Account Invoices
    Account_Cost_Multipliers = 'Account_Cost_Multipliers', // View Account Cost Multipliers
    Account_Prefixes = 'Account_Prefixes', // View Account Prefixes
    Recall_Requests = 'Recall_Requests', // View/Search Recall Requests
    Disposal_Requests = 'Disposal_Requests', // View/Search Disposals Requests
    Inventory_Reports = 'Inventory_Reports', // View/Download Inventory Reports
    Workstations = 'Workstations', // View Workstations
    Volumes = 'Volumes', // View Volumes
    Delivery_Methods = 'Delivery_Methods', // View Delivery Methods
    Packing_Box_Label = 'Packing_Box_Label', // View Packing Box Label
    Outer_Cube_Label = 'Outer_Cube_Label', // View Outer Cube Label
    PII_Notes = 'PII_Notes', // View PII Notes (alias for Inventory_Sensitive_Notes)
    Non_PII_Notes = 'Non_PII_Notes', // View Non-PII Notes (alias for Inventory_Search_Notes)

    // New Manage/Edit permissions
    Manage_Case = 'Manage_Case', // Manage Case
    Manage_Range = 'Manage_Range', // Manage Range
    Add_Outer_Cube = 'Add_Outer_Cube', // Add An Outer Cube
    Manage_Packing_Box = 'Manage_Packing_Box', // Manage Packing Box
    Edit_Specimen = 'Edit_Specimen', // Edit Specimen
    Delete_Outer_Cube = 'Delete_Outer_Cube', // Delete An Outer Cube
    Move_Outer_Cube = 'Move_Outer_Cube', // Move An Outer Cube
    Operate_Workstation = 'Operate_Workstation', // Operate Workstation
    Add_Account = 'Add_Account', // Add Account
    Edit_Account = 'Edit_Account', // Edit Account
    Manage_Account_User = 'Manage_Account_User', // Manage Account User (alias for Customer_Account_Users)
    Manage_Account_Address_Book = 'Manage_Account_Address_Book', // Manage Account Address Book
    Edit_Account_Cost_Multiplier = 'Edit_Account_Cost_Multiplier', // Edit Account Cost Multiplier
    Manage_Account_Prefixes = 'Manage_Account_Prefixes', // Manage Account Prefixes
    Make_Recall_Request = 'Make_Recall_Request', // Make A Recall Request
    Make_Disposal_Request = 'Make_Disposal_Request', // Make A Disposal Request
    Manage_Recalls = 'Manage_Recalls', // Manage Recalls
    Edit_Recall = 'Edit_Recall', // Edit Recall
    Manage_Documentation = 'Manage_Documentation', // Manage Documentation
    Manage_CellTrak_Operator = 'Manage_CellTrak_Operator', // Manage CellTrak Operator
    Manage_Volumes = 'Manage_Volumes', // Manage Volumes
    Manage_Delivery_Methods = 'Manage_Delivery_Methods', // Manage Delivery Methods
    Permanent_Account_Removal = 'Permanent_Account_Removal', // Permanent Account Removal (alias for Remove_Account)
    Manage_API_Access = 'Manage_API_Access', // Manage API Access
    Return_Packing_Boxes = 'Return_Packing_Boxes', // Return Packing Boxes
    Account_OrderNumbers = 'Account_OrderNumbers', // View/Search Account Order Numbers
    Manage_Account_OrderNumbers = 'Manage_Account_OrderNumbers', // Manage Account Order Numbers
    Manage_Locations = 'Manage_Locations', // Manage Locations
    Manage_Case_Material_Types = 'Manage_Case_Material_Types', // Manage Case Material Types
    Edit_PII_Notes = 'Edit_PII_Notes', // Edit PII Notes
    Edit_Non_PII_Notes = 'Edit_Non_PII_Notes', // Edit Non-PII Notes
}
